import { defineMessages } from 'react-intl';

export const i18n: {
	quickSummaryLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	quickSummaryToolTipText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	quickSummaryFeatureSpotlightText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	quickSummarySpotlightSummarizeText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	quickSummarySpotlightCloseButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	quickSummaryOptInDialogHeaderText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	quickSummaryOptInDialogBodyText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	quickSummaryAdminOptInDialogBodyText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	quickSummaryLabel: {
		id: 'quick-summary.label.text',
		defaultMessage: 'Quick summary',
		description:
			'The text is shown as the label for the Quick Summary feature panel heading when an AI-generated page summary is displayed to the user.',
	},
	quickSummaryToolTipText: {
		id: 'quick-summary.tooltip.text',
		defaultMessage: 'Summarize',
		description:
			'The text is shown as a tooltip when the user hovers over the Quick Summary icon button in the page toolbar, indicating that clicking it will generate an AI summary of the page.',
	},
	quickSummaryFeatureSpotlightText: {
		id: 'quick-summary.feature-spotlight-one.text',
		defaultMessage:
			'This might be a longer read. Save time and read a quick summary from Atlassian Intelligence.',
		description:
			'The text is shown as the body of a feature spotlight tooltip that appears on long pages, encouraging users to use the Quick Summary feature to save reading time with Atlassian Intelligence.',
	},
	quickSummarySpotlightSummarizeText: {
		id: 'quick-summary.spotlight.summarize.button.text',
		defaultMessage: 'Summarize',
		description:
			'The text is shown on the primary action button inside the Quick Summary feature spotlight tooltip. Clicking it triggers generation of an AI summary of the current page.',
	},
	quickSummarySpotlightCloseButtonText: {
		id: 'quick-summary.spotlight.close.button.text',
		defaultMessage: 'Dismiss',
		description:
			'The text is shown on the dismiss button inside the Quick Summary feature spotlight tooltip, allowing the user to close the spotlight without generating a summary.',
	},
	quickSummaryOptInDialogHeaderText: {
		id: 'quick-summary.opt-in.dialog.header.text',
		defaultMessage: 'Work smarter, not harder',
		description: 'Header text for Quick Summary AI Opt In Dialog',
	},
	quickSummaryOptInDialogBodyText: {
		id: 'quick-summary.opt-in.dialog.body.text.livedocs',
		defaultMessage:
			'Save time by reading an Al-generated summary instead of an entire page, live doc, or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration.',
		description: 'Updated version of quick-summary.opt-in.dialog.body.text',
	},
	quickSummaryAdminOptInDialogBodyText: {
		id: 'quick-summary.admin.opt-in.dialog.body.text.livedocs',
		defaultMessage:
			'Save your team time by reading an Al-generated summary instead of an entire page or live doc with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration.',
		description: 'Updated version of quick-summary.admin.opt-in.dialog.body.text',
	},
});
